import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminUserService } from './services/admin-user.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AdminUserService],
})
export class UserModule {}
